module.exports = __webpack_public_path__ + "components/media-kit/static/social-desktop-a8892cf45e071b8f4e7b5ee87c6112d3.png";